import type { Dictionary } from '@ngrx/entity';

export function arrayInsert<T>(array: T[], element: T, index: number): T[] {
    const copy: T[] = [...array];
    copy.splice(index, 0, element);
    return copy;
}

export function filterByField<T>(field: keyof T, value: T[typeof field]) {
    return (item: T): boolean => item[field] !== value;
}

export function arrayLast<T>(array: T[]): T {
    return array[array.length - 1];
}

export function arrayFirst<T>(array: T[]): T {
    return array[0];
}

export function arrayLengthEq<T>(array: T[], value: number): boolean {
    return array.length === value;
}

export function arrayLengthGt<T>(array: T[], value: number): boolean {
    return array.length > value;
}

export function arrayLengthLt<T>(array: T[], value: number): boolean {
    return array.length < value;
}

export function arrayIsEmpty<T>(array: T[]): boolean {
    return arrayLengthEq(array, 0);
}

export function arrayToDictionary<T>(
    array: T[],
    callbackFn: (dictionary: Dictionary<T>, item: T) => Dictionary<T>
): Dictionary<T> {
    return array.reduce(callbackFn, {});
}

export function checkIfArrayIsNotEmpty<T>(array: T[]): boolean {
    if (!array) {
        return false;
    }

    if (array.length === 1 && Array.isArray(array[0])) {
        return false;
    }

    return Boolean(array.length);
}

export function groupBy<T>(
    array: T[],
    key: string | number | ((item: T) => string | number),
    valType: 'default' | 'count' = 'default'
): Dictionary<T[]> {
    return array.reduce((dictionary, item) => {
        const itemKey = typeof key === 'function' ? key(item) : item[key];
        const defaultVal = valType === 'count' ? 0 : [];
        let group = dictionary[itemKey] || defaultVal;

        return {
            ...dictionary,
            [itemKey]: typeof group === 'number' ? ++group : [...group, item],
        };
    }, {});
}
